<template>
  <section class="opensource">
    <div class="container">
      <h1>
        OpenSource
        <i class="fa fa-github"></i>
      </h1>
      <div v-if="fetching">Fetching...</div>
      <div v-else class="gutterize row wrap">
        <a
          v-for="item in items"
          :key="item.id"
          :href="item.html_url"
          target="_blank"
          class="opensource__item col"
        >
          <div class="opensource__item-content">
            <h3>{{ item.name }}</h3>
            <p>{{ item.description }}</p>
          </div>
          <div class="opensource__item-meta row between middle">
            <div class="opensource__item-pushedat">{{ item.pushed_at | date }}</div>
            <div>
              <i class="fa fa-star"></i>
              <span>{{ item.stargazers_count }}</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      fetching: false,
      endpoints: [
        "https://api.github.com/users/elderas/repos?per_page=100",
        "https://api.github.com/users/crsten/repos?per_page=100"
      ]
    };
  },
  methods: {
    fetch() {
      this.fetching = true;

      Promise.all(
        this.endpoints.map(endpoint => {
          return fetch(endpoint).then(res => res.json());
        })
      )
        .then(arr => [].concat.apply([], arr))
        .then(arr => arr.filter(item => !item.fork))
        .then(
          arr =>
            (this.items = arr.sort(
              (a, b) => new Date(b.pushed_at) - new Date(a.pushed_at)
            ))
        )
        .then(() => (this.fetching = false));
    }
  },
  created() {
    this.fetch();
  },
  filters: {
    date(val) {
      return new Date(val).toLocaleDateString();
    }
  }
};
</script>

<style lang="scss">
@import "../styles/base/_variables";
$break: 600px;

.opensource {
  background-color: #d9dee8;
  padding: 4rem;

  @media (max-width: $break) {
    padding: 1rem;
  }

  h1 {
    font-size: 1.5em;
    margin-bottom: 2rem;
  }

  &__item {
    min-width: 350px;
    width: calc(50% - 2rem);
    border-radius: $borderRadius;
    background-color: #61708c;
    text-decoration: none;
    color: white;

    @media (max-width: $break) {
      width: 100%;
      min-width: initial;
    }

    &-content {
      padding: 2rem;
    }

    &-meta {
      margin-top: auto;
      padding: 2rem;
      background-color: rgba(black, 0.2);
    }

    &-pushedat {
      opacity: 0.7;
    }
  }
}
</style>
